import { Table as TableIcon } from "@untitledui/icons";
import { EmptyState } from "@/components/application/empty-state/empty-state";

type SafetyEmptyStateProps = {
  title: string;
  subtitle: string;
  width: string;
  height: string;
};

export const SafetyEmptyState = ({ title, subtitle, width, height }: SafetyEmptyStateProps) => (
  <div
    className="flex items-center justify-center rounded-xl bg-white border border-border-primary"
    style={{ width, height }}
  >
    <EmptyState size="md">
      <div className="pb-6">
        <EmptyState.FeaturedIcon icon={TableIcon} color="gray" />
      </div>
      <EmptyState.Content>
        <EmptyState.Title>{title}</EmptyState.Title>
        <EmptyState.Description>{subtitle}</EmptyState.Description>
      </EmptyState.Content>
    </EmptyState>
  </div>
);
